// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Top from '@/components/Top'
import router from './router'
import firebase from 'firebase/app'

Vue.config.productionTip = false

//-----------------
// firebase初期化
//-----------------
const firebaseConfig = {
  apiKey: "AIzaSyAXj0Gt1jm6iNd-76ACsKLjw0tvygExYQk",
  authDomain: "daredemo-40b01.firebaseapp.com",
  databaseURL: "https://daredemo-40b01.firebaseio.com",
  projectId: "daredemo-40b01",
  storageBucket: "daredemo-40b01.appspot.com",
  messagingSenderId: "1093039856278",
  appId: "1:1093039856278:web:6432e09f7389a2df"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

//--------------
// 定数
//--------------
Vue.prototype.$moreAmount = 10;
Vue.prototype.$maxAmount = {
  nothing : 50,
  music : 30,
  game : 30,
  news : 30,
  movie : 30,
  anime : 30
};

//----------------
// 共通フィルター
//----------------
// firestore.timestampを（n分前）とかの簡易表示にする
Vue.filter("simpleDate", function(timestamp){
  if(!timestamp) return "";
  const jsDate = timestamp.toDate();
  const jsSeconds = (Date.now() - jsDate.getTime()) / 1000;
  if(jsSeconds < 60) return "たった今";
  else if(jsSeconds < 60 * 60) return Math.floor(jsSeconds / 60) + "分前";
  else if(jsSeconds < 60 * 60 * 24) return Math.floor(jsSeconds / (60 * 60)) + "時間前";
  else if(jsSeconds < 60 * 60 * 24 * 365) return Math.floor(jsSeconds / (60 * 60 * 24)) + "日前";
  else return "1年以上前";
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<Top/>',
  components: { Top }
});



// WEBPACK FOOTER //
// ./src/main.js